import React, { PropTypes } from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { InlineOverlay, InlineOverlayHeader, InlineOverlayFooter, InlineOverlayBody, InlineOverlayCloseButton } from '@bibliocommons/base-inline-overlay';
import { PrimaryButton } from '@bibliocommons/base-buttons';
import { Checkmark } from '@bibliocommons/base-icons';
import { GenericForm } from '@bibliocommons/shared-messages';

import { MATERIAL_TYPE_DIGITAL } from '../../../../../../constants/BibConstants';
import MessagingContainer from '../../../../../../containers/shared/Messaging/MessagingContainer';
import DigitalFormats from '../../digital-formats';
import DigitalNotificationEmail from '../../digital-notification-email/';
import EnableAutoCheckouts from '../../digital-auto-checkouts/';
import BibBrief from '@bibliocommons/shared-bib-brief';

export class DigitalHoldsWorkflowView extends BcReactComponent {
  constructor(props) {
    super(props);
    this.state = {
      digitalNotificationEmail: this.props.digitalNotificationEmail,
      autoCheckoutsEnabled: this.props.autoCheckoutsEnabled,
      format: null
    };

    this.bindAll('handleSubmit', 'handleEmailChange', 'handleAutoCheckoutChange');
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.placeHold({
      workflowId: this.props.workflowId,
      messagingId: this.props.messagingId,
      accountId: this.props.accountId,
      metadataId: this.props.bib.get('id'),
      materialType: MATERIAL_TYPE_DIGITAL,
      enableSingleClickHolds: false,
      materialParams: {
        email: this.state.digitalNotificationEmail,
        autoCheckout: this.state.autoCheckoutsEnabled,
        format: this.state.format
      }
    });
  }

  handleEmailChange(e) {
    const digitalNotificationEmail = e.target.value;
    this.setState({
      digitalNotificationEmail
    });
  }

  handleAutoCheckoutChange(autoCheckoutsEnabled) {
    this.setState({
      autoCheckoutsEnabled
    });
  }

  getColumnClasses() {
    if (this.props.showFormatDuringHold) {
      return 'col-xs-12 col-md-6';
    }
    return 'col-xs-12';
  }

  renderQuickstartLink() {
    const { showQuickStartLink, quickStartUrl } = this.props;

    if (showQuickStartLink) {
      return <FormattedHTMLMessage id="digital_download_quickstart_link" values={{ quickStartUrl }} />;
    }

    return null;
  }

  renderFormats() {
    const { formats, provider, showFormatDuringHold, requiresFormatDuringHold, fetchDigitalFormats, bib } = this.props;
    if (showFormatDuringHold) {
      return (
        <div className={this.getColumnClasses()}>
          <DigitalFormats
            metadataId={bib.get('id')}
            formats={formats}
            provider={provider}
            requireFormats={requiresFormatDuringHold}
            fetchDigitalFormats={fetchDigitalFormats} />
          {this.renderQuickstartLink()}
        </div>
      );
    }

    return null;
  }

  render() {
    const { handleClose, bib, isLoading, supportAutoCheckout, messagingId } = this.props;
    return (
      <InlineOverlay handleClose={handleClose}>
        <form action="#submit-digital" onSubmit={this.handleSubmit}>
          <InlineOverlayHeader>
            <FormattedMessage id="request_this_title" />
          </InlineOverlayHeader>
          <InlineOverlayBody>
            <div className="row">
              <MessagingContainer id={messagingId}>
                {
                  messageOptions => <GenericForm {...messageOptions} />
                }
              </MessagingContainer>
              <div className={this.getColumnClasses()}>
                <BibBrief bib={bib} titleTag="h3" renderTitleAsLink={false} renderAuthorsAsLink={false} />
                <EnableAutoCheckouts supportAutoCheckout={supportAutoCheckout} handleChange={this.handleAutoCheckoutChange} />
                <DigitalNotificationEmail value={this.state.digitalNotificationEmail} onChange={this.handleEmailChange} />
              </div>
              {this.renderFormats()}
            </div>
          </InlineOverlayBody>
          <InlineOverlayFooter>
            <PrimaryButton type="submit" className="pull-right" isLoading={isLoading}>
              <Checkmark color="#FFF" /> <FormattedMessage id="form_label_place_a_digital_hold" />
            </PrimaryButton>
            <InlineOverlayCloseButton className="btn btn-link pull-right">
              <FormattedMessage id="button_nevermind_close" />
            </InlineOverlayCloseButton>
          </InlineOverlayFooter>
        </form>
      </InlineOverlay>
    );
  }
}

DigitalHoldsWorkflowView.propTypes = {
  handleClose: PropTypes.func.isRequired,
  bib: PropTypes.shape({
    id: PropTypes.string
  }).isRequired,
  isLoading: PropTypes.bool,
  formats: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    hasDownloadLink: PropTypes.bool
  })).isRequired,
  provider: PropTypes.string.isRequired,
  supportAutoCheckout: PropTypes.bool.isRequired,
  accountId: PropTypes.number.isRequired,
  digitalNotificationEmail: PropTypes.string,
  placeHold: PropTypes.func.isRequired,
  requiresFormatDuringHold: PropTypes.bool.isRequired,
  showFormatDuringHold: PropTypes.bool.isRequired,
  fetchDigitalFormats: PropTypes.func.isRequired,
  workflowId: PropTypes.string,
  messagingId: PropTypes.string
};

DigitalHoldsWorkflowView.displayName = 'DigitalHoldsWorkflowView';

export default DigitalHoldsWorkflowView;



// WEBPACK FOOTER //
// ./app/components/shared/ItemTransactions/components/digital-holds-workflow-view/components/DigitalHoldsWorkflowView.component.jsx